import { Attr, Model } from "spraypaint";

import ScheduledReportSpecificationSchedule from "shared/resources/ScheduledReportSpecificationSchedule";
import { objectDirtyChecker } from "shared/services/spraypaint";

@Model()
class InsightsScheduledExport extends ScheduledReportSpecificationSchedule {
  static jsonapiType = "insights_scheduled_exports";

  @Attr() enabled: boolean;

  @Attr() instantInsightsReportId: number;

  @Attr() latestStreamReportPdfUrl?: string;

  @Attr({ dirtyChecker: objectDirtyChecker })
  mentionStreams: { id: number; label: string }[];

  @Attr() name: string;

  @Attr({ dirtyChecker: objectDirtyChecker })
  owner: { id: number; name: string };

  @Attr({ dirtyChecker: objectDirtyChecker }) recipients: string[];

  @Attr() scheduledReportSpecificationId: number;

  @Attr() timeframe: string;
}

export default InsightsScheduledExport;
